import * as React from "react"
import { Grid, Skeleton } from "@mui/material"
import { generateArrayByNumber } from "@ui-seeker/utils"


export default function StockSummarySkeleton() {
    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <Skeleton variant="rectangular" height={20} />
        </Grid>
        {generateArrayByNumber(6).map(idx => <Grid item xs={2} key={idx}>
            <Skeleton variant="rectangular" height={150} />
        </Grid>)}
    </Grid>
}